var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.787 28.991H4.137a3.212 3.212 0 0 1-2.223-.92A3.051 3.051 0 0 1 1 25.891V4.117a3.05 3.05 0 0 1 .908-2.19A3.212 3.212 0 0 1 4.138 1h37.649c.839.01 1.64.343 2.227.927a3.05 3.05 0 0 1 .906 2.19V25.89a3.051 3.051 0 0 1-.912 2.179 3.213 3.213 0 0 1-2.221.921Z",
    fill: "#EEE",
    stroke: "#DDD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.865 32.999H8.216a3.212 3.212 0 0 1-2.224-.92 3.051 3.051 0 0 1-.914-2.18V8.124a3.05 3.05 0 0 1 .908-2.19 3.212 3.212 0 0 1 2.23-.926h37.649c.839.01 1.64.343 2.227.927.587.584.913 1.371.906 2.189v21.775a3.052 3.052 0 0 1-.912 2.178 3.212 3.212 0 0 1-2.221.922Z",
    fill: "#EEE",
    stroke: "#DDD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.342 28h-3.474a.815.815 0 0 1-.614-.293A1.082 1.082 0 0 1 11 27c0-.265.091-.52.254-.707a.815.815 0 0 1 .614-.293h3.474c.23 0 .451.105.614.293.163.187.255.442.255.707 0 .265-.092.52-.255.707a.815.815 0 0 1-.614.293Zm9.553 0H21.42a.815.815 0 0 1-.614-.293 1.082 1.082 0 0 1-.254-.707c0-.265.091-.52.254-.707a.815.815 0 0 1 .614-.293h3.474c.23 0 .45.105.614.293.163.187.254.442.254.707 0 .265-.091.52-.254.707a.815.815 0 0 1-.614.293Zm8.684 0h-3.474a.815.815 0 0 1-.614-.293 1.082 1.082 0 0 1-.254-.707c0-.265.091-.52.254-.707a.815.815 0 0 1 .614-.293h3.474c.23 0 .451.105.614.293.163.187.254.442.254.707 0 .265-.091.52-.254.707a.815.815 0 0 1-.614.293Zm9.553 0h-3.474a.815.815 0 0 1-.614-.293 1.082 1.082 0 0 1-.255-.707c0-.265.092-.52.255-.707a.815.815 0 0 1 .614-.293h3.474c.23 0 .45.105.614.293.162.187.254.442.254.707 0 .265-.092.52-.254.707a.815.815 0 0 1-.614.293Z",
    fill: "#8E8E8E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    width: 33,
    height: 2.004,
    rx: 1.002,
    fill: "#8E8E8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 16,
    height: 2.004,
    rx: 1.002,
    fill: "#8E8E8E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 24,
    height: 2.004,
    rx: 1.002,
    fill: "#8E8E8E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-back.9fb65a92d630ace85682c574926c4235.svg";